module.exports = __webpack_public_path__ + "static/img/headBg.3603ddf.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/depositDetail/headBg.webp
// module id = 5i3w
// module chunks = 0